import React from 'react';
import { Collapse } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import styles from './index.module.scss';

const faqData = [
  {
    label: 'totalBountyAlloc',
    content: 'totalBountyPoolEqu',
  },
  {
    label: 'bountyDistrib',
    content: ['firstReporterInfo', 'entityExecFundFreeze', 'defOfEvidence'],
  },
  {
    label: 'valuatFrozenFunds',
    content: 'bountyCalculationInfo',
  },
  {
    label: 'valuatNonFrozenFund',
    content: 'unfrozenFundsInfo',
  },
  {
    label: 'fallbackValMethod',
    content: 'tokenNotListedOnBybit',
  },
  {
    label: 'finalAuthority',
    content: 'bybitBountyProgram',
  },
];

export const FAQ: React.FC = () => {
  const fm = useFm();

  const items = faqData.map(({ label, content }) => ({
    label: <span className={styles.label}>{fm(label)}</span>,
    key: label,
    // 每行样式不同，先定制化处理一下
    children: (
      <div className={styles.content}>
        {Array.isArray(content) ? (
          <>
            <div>{`• ${fm(content[0])}`}</div>
            <div>{`• ${fm(content[1])}`}</div>
            <div style={{ marginTop: '24px' }}>
              <em>{fm(content[2])}</em>
            </div>
          </>
        ) : (
          fm(content)
        )}
      </div>
    ),
  }));

  return (
    <div className="max-w-[1200px] min-[768px]:mx-auto min-[768px]:mt-10 min-[768px]:pb-20 pb-10 max-[768px]:px-4">
      <div className={styles.title}>{fm('bountyProgMethod')}</div>
      <div className={styles.content}>{fm('atBybitValueContrib')}</div>
      <div className={styles.container}>
        <Collapse
          items={items}
          collapsible
          defaultValue={faqData[0].label}
          className={styles.collapse}
        />
      </div>
      <div className={styles.disclaimer}>
        <em>{fm('bountyProgramDisclaimer')}</em>
      </div>
    </div>
  );
};
